// Demo videos view page

import { Box,Typography } from '@mui/material';
import { useNavigate,Link } from 'react-router-dom';
import DemoVideoList from './DemoVideosList';
import { ARROW } from '../../../constants/Common';
import FloatingButton from '../helpdesk/FloatingButton';


 function DemoVideosPage(){
    return(
        <Box sx={{ mt: '-60px' }}>
        <Box>
          <Typography variant='h6' gutterBottom>
            <Link to={'/usersupporthome'}>User Support</Link> {ARROW } Demo Videos
          </Typography>
        </Box>
        <DemoVideoList />
        <FloatingButton/>
        </Box>
    )
 }
 export default DemoVideosPage;